/**
 * Plan tab action button styles (Create Units / Add Topics tree headers).
 * Primary: action-blue. Destructive: destructive-action. Confirm: confirm-action.
 */

const primaryBase =
    'bg-action-blue hover:bg-action-blue-dark text-white font-medium transition-colors';

const destructiveBase =
    'bg-destructive-action hover:bg-destructive-action-dark text-white font-medium transition-colors';

const createYourOwnBase =
    'bg-confirm-action hover:bg-confirm-action-dark text-white font-medium transition-colors';

/** “Create Your Own” in the curriculum library column (compact and full-width). */
export const planCreateYourOwnCompactButtonClass =
    `${createYourOwnBase} px-3 py-1.5 rounded text-sm font-normal flex items-center justify-center space-x-1.5`;

export const planCreateYourOwnFloatingButtonClass =
    `${createYourOwnBase} px-6 py-4 rounded-lg flex items-center justify-center space-x-2 shadow-lg w-full`;

/** Compact primary actions in Plan tree columns (Create Unit, Add To Student Curriculum, Create Assessment). */
export const planCreateUnitCompactButtonClass =
    `${primaryBase} px-3 py-1.5 rounded text-sm font-normal flex items-center justify-center space-x-1.5`;

export const planDestructiveCompactButtonClass =
    `${destructiveBase} px-3 py-1.5 rounded text-sm font-normal flex items-center justify-center space-x-1.5`;

/** Outline secondary: clear selection (not remove-from-curriculum). */
export const planSecondaryOutlineCompactButtonClass =
    'border border-abbey text-abbey hover:bg-edgewater bg-white px-3 py-1.5 rounded text-sm font-normal flex items-center justify-center space-x-1.5 transition-colors';
